export const _setIsProfB2DataLoaded = (state, action) => {
  state.isProfB2DataLoaded = action.payload;
};

export const _setAlcohol = (state, action) => {
  state.alcohol = action.payload;
};

export const _setMethamphetamine = (state, action) => {
  state.methamphetamine = action.payload;
};

export const _setCocaine = (state, action) => {
  state.cocaine = action.payload;
};

export const _setHeroin = (state, action) => {
  state.heroin = action.payload;
};

export const _setMarijuanaHash = (state, action) => {
  state.marijuanaHash = action.payload;
};
export const _setEcstacy = (state, action) => {
  state.ecstacy = action.payload;
};

export const _setPCP = (state, action) => {
  state.PCP = action.payload;
};

export const _setLSDHallucinogens = (state, action) => {
  state.LSDHallucinogens = action.payload;
};

export const _setInhalants = (state, action) => {
  state.inhalants = action.payload;
};

export const _setPrescription = (state, action) => {
  state.prescription = action.payload;
};
export const _setPolyDrugUser = (state, action) => {
  state.polyDrugUser = action.payload;
};
export const _setSubstanceUseHistoryOther = (state, action) => {
  state.substanceUseHistoryOther = action.payload;
};
export const _setSubstanceUseHistoryComment = (state, action) => {
  state.substanceUseHistoryComment = action.payload;
};
export const _setPA2ConcernsNone = (state, action) => {
  state.PA2ConcernsNone = action.payload;
};
export const _setSex = (state, action) => {
  state.sex = action.payload;
};
export const _setArson = (state, action) => {
  state.arson = action.payload;
};
export const _setViolence = (state, action) => {
  state.violence = action.payload;
};
export const _setChildAbuse = (state, action) => {
  state.childAbuse = action.payload;
};
export const _setDomesticViolence = (state, action) => {
  state.domesticViolence = action.payload;
};
export const _setPOC = (state, action) => {
  state.POC = action.payload;
};
export const _setWeapons = (state, action) => {
  state.weapons = action.payload;
};
export const _setGangs = (state, action) => {
  state.gangs = action.payload;
};
export const _setEnemies = (state, action) => {
  state.enemies = action.payload;
};
export const _setADA = (state, action) => {
  state.ADA = action.payload;
};
export const _setMedical = (state, action) => {
  state.medical = action.payload;
};
export const _setPsychiatric = (state, action) => {
  state.psychiatric = action.payload;
};
export const _setVictims = (state, action) => {
  state.victims = action.payload;
};
export const _setElderAbuse = (state, action) => {
  state.elderAbuse = action.payload;
};
export const _setPA2ConcernsOthers = (state, action) => {
  state.PA2ConcernsOthers = action.payload;
};
export const _setPA2DirectionsNone = (state, action) => {
  state.PA2DirectionsNone = action.payload;
};
export const _setNoCoEdProgram = (state, action) => {
  state.noCoEdProgram = action.payload;
};
export const _setNoContactwithMinors = (state, action) => {
  state.noContactwithMinors = action.payload;
};
export const _setNoFOTEP = (state, action) => {
  state.noFOTEP = action.payload;
};
export const _setMedicalConcerns = (state, action) => {
  state.medicalConcerns = action.payload;
};
export const _setPA2DirectionsComments = (state, action) => {
  state.PA2DirectionsComments = action.payload;
};
export const _setTIP = (state, action) => {
  state.TIP = action.payload;
};
export const _setFOTEP = (state, action) => {
  state.FOTEP = action.payload;
};
export const _setEligibleTo2933 = (state, action) => {
  state.eligibleTo2933 = action.payload;
};
export const _setInEligibleTo2933 = (state, action) => {
  state.inEligibleTo2933 = action.payload;
};
export const _setOSAPAgentsGeneralComments = (state, action) => {
  state.OSAPAgentsGeneralComments = action.payload;
};
export const _setDateScreened = (state, action) => {
  state.dateScreened = action.payload;
};
export const _setOSAPParoleAgentId = (state, action) => {
  state.OSAPParoleAgentId = action.payload;
};
